<template>
<div>
  <v-card>
        <TradeRequestDirectListsOfResponsesPerItem></TradeRequestDirectListsOfResponsesPerItem>
      <!-- </v-card-text> -->
  </v-card>
</div>
</template>
<script>
import TradeRequestDirectListsOfResponsesPerItem from '../components/TradeRequestDirectListsOfResponsesPerItem.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestDirectListsOfResponsesPerItem
  },
  methods: {
    
  },
};
</script>

<style></style>